export const splitToSeparateLines = (text?: string): string[] => {
  if (!text) {
    return [];
  }

  return text.split('\n');
};
